// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-labfront.container .kb-sector-selector .ui.dropdown.search.selection.active.visible .divider.text {
  display: none;
}
.kb-labfront.container .kb-sector-selector .ui.dropdown.search.selection .divider.text {
  color: #000;
}
.kb-labfront.container .kb-sector-selector .ui.dropdown.search.selection .menu > .item {
  font-weight: 200;
}
.kb-labfront.container .kb-sector-selector .ui.dropdown.search.selection .menu > .item.active {
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/pageElements/KbSectorSelector/KbSectorSelector.scss"],"names":[],"mappings":"AAMQ;EACE,aAAA;AALV;AAQM;EACE,WAAA;AANR;AAQM;EACE,gBAAA;AANR;AAOQ;EACE,gBAAA;AALV","sourcesContent":[".kb-labfront.container {\n  .kb-sector-selector {\n    $use-dropdown: true !default;\n    $use-segment: true !default;\n    .ui.dropdown.search.selection {\n      &.active.visible {\n        .divider.text  {\n          display: none;\n        }\n      }\n      .divider.text {\n        color: #000;\n      }\n      .menu > .item {\n        font-weight: 200;\n        &.active {\n          font-weight: 400;\n        }\n      }\n    } \n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
